var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loaded)?_c('v-progress-linear',{attrs:{"color":"green","indeterminate":true}}):_c('div',[_c('v-card',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.logs,"dense":""},scopedSlots:_vm._u([{key:"item.email",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.email.split('@')[0])+" ")]}},{key:"item.timestamp",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatDate(item.key))+" ")]}}])})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }